import adminApi from "../../api";

class UserService {
  async login(username, password) {
    const credentials = btoa(`${username}:${password}`);
    sessionStorage.setItem("credentials", credentials);

    try {
      // Проверяем, что креды реально подходят (роут защищён Basic Auth)
      await adminApi.get("/auth/check");
      return true;
    } catch (e) {
      sessionStorage.removeItem("credentials");
      throw e;
    }
  }

  logout() {
    sessionStorage.removeItem("credentials");
  }

  isAuthenticated() {
    return sessionStorage.getItem("credentials") !== null;
  }

  async checkAuth() {
    if (!this.isAuthenticated()) return false;
    try {
      await adminApi.get("/auth/check");
      return true;
    } catch (e) {
      this.logout();
      return false;
    }
  }
}

export default new UserService();
